import { gql } from '@apollo/client';

export const SEND_CONFIRMATION_EMAIL_MUTATION = gql`
  mutation SendConfirmationEmailMutation($userId: Int!, $bodyBuilder: FunctionType) {
    sendConfirmationEmail(userId: $userId, bodyBuilder: $bodyBuilder)
      @rest(
        type: "Void"
        path: "auth/v1/users/{args.userId}/email/confirmation/send"
        method: "POST"
        endpoint: "authentication"
        bodyBuilder: $bodyBuilder
      ) {
      _
    }
  }
`;
